<div class="dialog-content-wrapper admin_modal global-modal prsn_dialog">
  <button class="closeModal" (click)="closeModal()"><img src="../../assets/icons/close_mpdal_icon.svg"></button>
  <div class="modal_section">
    <h2>{{modalTitle}}</h2>
    <div *ngIf="action == 'AddKeyFeature' || action == 'EditKeyFeature'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Key Feature</mat-label>
                <input matInput type="text" class="form-control" [(ngModel)]="InputData.KeyFeatureName"
                  name="ServiceItemName" required>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
              (click)="dialogRef.close(InputData)">
              <span >{{action == 'AddKeyFeature'?"Save":"Update"}}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
     <div *ngIf="action == 'AddPurposeOfTravel' || action == 'EditPurposeOfTravel'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Purpose Of Travel</mat-label>
                <input matInput type="text" class="form-control" [(ngModel)]="InputData.PurposeOfTravelName"
                  name="ServiceItemName" required>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
              (click)="dialogRef.close(InputData)">
              <span >{{action == 'AddPurposeOfTravel'?"Save":"Update"}}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="action == 'AddBufferPercentage' || action == 'EditBufferPercentage'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline" >
                <mat-label>Buffer Percentage</mat-label>
                <input matInput type="number" class="form-control" [(ngModel)]="InputData.BufferPercentageName"
                  name="ServiceItemName" required>
                <span matSuffix class="suffix-percent1">%</span>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
              (click)="dialogRef.close(InputData)">
              <span >{{action == 'AddBufferPercentage'?"Save":"Update"}}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="action == 'AddEstimationBuffer' || action == 'EditEstimationBuffer'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Estimation Buffer</mat-label>
                <input matInput type="text" class="form-control" [(ngModel)]="InputData.EstimationBufferName"
                  name="ServiceItemName" required>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
              (click)="dialogRef.close(InputData)">
              <span >{{action == 'AddEstimationBuffer'?"Save":"Update"}}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="action == 'AddServiceItems' || action == 'EditServiceItems'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate
          autocomplete="off">
          <div class="col-sm-12">
            <mat-form-field appearance="outline">
              <mat-label>Service Category</mat-label>
              <mat-select class="form-control" [(ngModel)]="InputData.ServiceCategoryId"
              name="VendorServiceCategory" [compareWith]="compareFn">
                <fuse-mat-select-search name="search" [(ngModel)]="tree35">
                </fuse-mat-select-search>
                <mat-option *ngFor="let d_list of ProjectTypeDropDownLists | filter : tree35" [value]="d_list.Id">
                  {{d_list.LeadCategoryName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Service Name</mat-label>
                <input matInput type="text" class="form-control"
                  [(ngModel)]="InputData.ServiceItemName" name="ServiceItemName" required>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(InputData)">
              <span *ngIf="action == 'AddServiceItems'">Save</span>
              <span *ngIf="action == 'EditServiceItems'">Update</span>
            </button>
          </div>
        </form>
      </div>
    </div>


    <div *ngIf="action == 'AddServiceCategory' || action == 'EditServiceCategory'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate
          autocomplete="off">
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Service Category</mat-label>
                <input matInput type="text" class="form-control"
                  [(ngModel)]="InputData.VendorServiceName" name="ServiceCategoryName" required>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(InputData)">
              <span *ngIf="action == 'AddServiceCategory'">Save</span>
              <span *ngIf="action == 'EditServiceCategory'">Update</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="action == 'AddVendorSegment' || action == 'EditVendorSegment'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate
          autocomplete="off">
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Vendor Segment</mat-label>
                <input matInput type="text" class="form-control"
                  [(ngModel)]="InputData.VendorSegment" name="VendorSegment" required>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(InputData)">
              <span *ngIf="action == 'AddVendorSegment'">Save</span>
              <span *ngIf="action == 'EditVendorSegment'">Update</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="action == 'AddProjectType' || action == 'EditProjectType'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate
          autocomplete="off">
          <div class="col-sm-12">
            <mat-form-field appearance="outline">
              <mat-label>Project Category</mat-label>
              <mat-select class="form-control" [(ngModel)]="InputData.LeadCategoryId"
              name="LeadCategoryName" >
                <fuse-mat-select-search name="search" [(ngModel)]="tree35">
                </fuse-mat-select-search>
                <mat-option *ngFor="let d_list of ProjectTypeDropDownLists | filter : tree35" [value]="d_list.Id">
                  {{d_list.LeadCategoryName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Project Type</mat-label>
                <input matInput type="text" class="form-control"
                  [(ngModel)]="InputData.LeadTypeName" name="LeadTypeName" required>
              </mat-form-field>
            </div>
          </div>
            <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>HSN/SAC</mat-label>
                <mat-select class="form-control" [(ngModel)]="InputData.SACCode" name="SACCode"
                  [compareWith]="compareFn">
                  <fuse-mat-select-search name="search" [(ngModel)]="tree35">
                  </fuse-mat-select-search>
                  <mat-option *ngFor="let d_list of HsnDropList | filter : tree35" [value]="d_list">
                    {{d_list.HSNCode}} - {{d_list.HSNPercent}}%</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(InputData)">
              <span *ngIf="action == 'AddProjectType'">Save</span>
              <span *ngIf="action == 'EditProjectType'">Update</span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <div *ngIf="action == 'AddProjectCategory' || action == 'EditProjectCategory'">
      <div>
        <form class="row " autocomplete="off" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate
          autocomplete="off">
          <div class="col-sm-12">
            <mat-form-field appearance="outline">
              <mat-label>SBU</mat-label>
              <mat-select class="form-control" [(ngModel)]="ProjectCategoryInput.CostCenterCategory"
                (selectionChange)="getSBHName($event)" name="CostCenterCategory" [compareWith]="compareFn">
                <fuse-mat-select-search name="search" [(ngModel)]="tree35">
                </fuse-mat-select-search>
                <mat-option *ngFor="let d_list of SBHDropDownLists | filter : tree35" [value]="d_list">
                  {{d_list.CostCenterCategoryName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class=" col-sm-12">
            <div class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>SBU Head</mat-label>
                <input matInput type="text" class="form-control"
                  [(ngModel)]="ProjectCategoryInput.CostCenterCategory.StrategicBusinessHead.EmployeeName"
                  name="EmployeeName" readonly required>
              </mat-form-field>
            </div>

          </div>
          <div class=" col-sm-12">
            <div class="" class="d-matlab">
              <mat-form-field appearance="outline">
                <mat-label>Project Category</mat-label>
                <input matInput type="text" class="form-control"
                  [(ngModel)]="ProjectCategoryInput.LeadCategoryName" name="ProjectCategory" required>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-sm-4">
            <button type="submit" mat-flat-button color="primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(ProjectCategoryInput)">
              <span *ngIf="action == 'AddProjectCategory'">Save</span>
              <span *ngIf="action == 'EditProjectCategory'">Update</span>
            </button>
          </div>
        </form>
      </div>
    </div>

<!-- Compliance  Category -->
<div *ngIf="action == 'AddCompliancecategory' || action == 'EditCompliancecategory'">
  <form class="row" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
    <div class="col-sm-12">
      <div style="margin-bottom: 20px;">
      <mat-radio-group class="mb-2" [(ngModel)]="InputData.ISGoverment" name="ISGoverment" required>
        <mat-radio-button [value]="true">Government</mat-radio-button>
        <mat-radio-button class="ml-3" [value]="false">Non Government</mat-radio-button>
      </mat-radio-group>
      </div>


      <mat-form-field appearance="outline">
        <mat-label>Category</mat-label>
        <input matInput type="text" [(ngModel)]="InputData.ComplianceCategoryName"
          #ComplianceCategoryName="ngModel" name="ComplianceCategoryName" class="form-control" required>
      </mat-form-field>
    </div>
    <div class="action-btn">
      <button type="submit" class="btn btn-primary" [disabled]="myForm.form.invalid"
        (click)="dialogRef.close(InputData)">
        {{InputData.ComplianceCategoryId ? 'Update' : 'Save'}}
      </button>
      <button type="button" class="btn btn-secondary" (click)="dialogRef.close(false)">
        Cancel
      </button>
    </div>
  </form>
</div>


    <!-- Compliance Sub Category -->
    <div *ngIf="action == 'AddComplianceSubcategory' || action == 'EditComplianceSubcategory'">
      <form class="row" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
        <div class="col-sm-12">

          <mat-form-field appearance="outline">
            <mat-label>Category</mat-label>
            <mat-select [(ngModel)]="InputData.ComplianceCategoryId" required name="ComplianceCategoryId">
              <mat-option [value]="list.ComplianceCategoryId" *ngFor="let list of categorylist">
                {{list.ComplianceCategoryName}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Sub Category Name</mat-label>
            <input matInput type="text" required [(ngModel)]="InputData.ComplianceSubCategoryName"
              name="ComplianceSubCategoryName" placeholder="Enter Sub Category Name" class="form-control" required>
          </mat-form-field>
        </div>
        <div class="action-btn">
          <button type="submit" class="btn btn-primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(InputData)">
            {{InputData.ComplianceId ? 'Update' : 'Save'}}
          </button>
          <button type="button" class="btn btn-secondary" (click)="dialogRef.close(false)">
            Cancel
          </button>
        </div>
      </form>
    </div>

    <!-- Compliance Department -->
    <div *ngIf="action == 'AddComplianceDepartment' || action == 'EditComplianceDepartment'">
      <form class="row" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Department Name</mat-label>
            <input matInput type="text" required [(ngModel)]="InputData.DepartmentName" name="DepartmentName"
              placeholder="Enter Department Name" class="form-control" required>
          </mat-form-field>
        </div>
        <div class="action-btn">
          <button type="submit" class="btn btn-primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(InputData)">
            {{InputData.DepartmentId ? 'Update' : 'Save'}}
          </button>
          <button type="button" class="btn btn-secondary" (click)="dialogRef.close(false)">
            Cancel
          </button>
        </div>
      </form>
    </div>


    <!-- Compliance Name -->
    <div *ngIf="action == 'AddCompliance' || action == 'EditCompliance'">
      <form class="row" (ngSubmit)="myForm.form.valid" #myForm="ngForm" novalidate autocomplete="off">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Compliance Name</mat-label>
            <input matInput type="text" required [(ngModel)]="InputData.ComplianceName" name="ComplianceName"
              placeholder="Enter Compliance Name" class="form-control" required>
          </mat-form-field>
        </div>
        <div class="action-btn">
          <button type="submit" class="btn btn-primary" [disabled]="myForm.form.invalid"
            (click)="dialogRef.close(InputData)">
            {{InputData.ComplianceNameId ? 'Update' : 'Save'}}
          </button>
          <button type="button" class="btn btn-secondary" (click)="dialogRef.close(false)">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
